export default {
  "pl": {
    "select": {
      "actions": {
        "clear": "Wyczyść",
        "filterProject": "Filtruj projekty",
        "filterUnit": "Filtruj jednostki",
        "noResults": "Brak wyników",
        "noResultsFor": "Brak wyników dla {search}",
        "reset": "Zresetuj",
        "selectCategory": "Wybierz kategorię",
        "setToday": "Dziś",
        "startTyping": "Zacznij pisać, aby wyszukać"
      },
      "groups": {
        "customers": "Klienci",
        "employees": "Członkowie zespołu"
      },
      "labels": {
        "allUnits": "Wszystkie jednostki",
        "contact": "Kontakt"
      }
    }
  }
}
